import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://nzqofoyofytgauzskuwi.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im56cW9mb3lvZnl0Z2F1enNrdXdpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjA0NjE0MjMsImV4cCI6MjAzNjAzNzQyM30.2pykY7G7ELav6VNqlAYTrlU5yXWMoj0MUiCU6XCqDv0';

export const supabase = createClient(supabaseUrl, supabaseKey);
